import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Продажа урожая',
} satisfies TMessages
